import { chevronBackOutline } from 'ionicons/icons';
import { addIcons } from 'ionicons';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { AppConfig } from '../../../../config/routes.config';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { CreateShareRequest, UpdateShareRequest, ShareDto } from 'src/app/api/models';
import { UserBookingsApiService } from 'src/app/api/services';
import { AlertType } from 'src/shared/models/enums';
import { ICustomControl } from 'src/shared/models/form.model';
import { CustomSpinnerService } from 'src/shared/services/helpers/custom-spinner.service';
import { DateHelperService } from 'src/shared/services/helpers/date-helper.service';
import { FormService } from 'src/shared/shared-forms/form.service';
import { IonNav, ModalController } from '@ionic/angular/standalone';
import { AlertService } from '@v-locker-app/v-locker-common';
import { SharedAccessSuccessfullyPage } from '../shared-access-successfully/shared-access-successfully.page';
import { SharedAccessLogsPage } from '../shared-access-logs/shared-access-logs.page';
import { SharedBookingsAccessListPage } from '../shared-bookings-access-list/shared-bookings-access-list.page';
import { SharedBookingAccessHelperService } from '../../services/shared-booking-access-helper.service';
import { EventsService } from 'src/shared/services/helpers/events.service';
import { IonButton, IonIcon, IonItem, IonLabel, IonToggle } from "@ionic/angular/standalone";
import { ContextHelpComponent } from "../../../../../shared/components/context-help/context-help.component";
import { BookingAccessInfoComponent } from "../../components/booking-access-info/booking-access-info.component";
import { InputComponent } from "../../../../../shared/components/elements/input/input.component";
import { DatePickerComponent } from "../../../../../shared/components/elements/date-picker/date-picker.component";
import { NgClass, NgFor, NgIf } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
	selector: 'vl-add-shared-booking-access',
	templateUrl: './add-shared-booking-access.page.html',
	styleUrls: ['./add-shared-booking-access.page.scss'],
	imports: [IonToggle, IonLabel, NgIf, NgClass, NgFor, ReactiveFormsModule, TranslatePipe, IonItem, IonButton, IonIcon, ContextHelpComponent, BookingAccessInfoComponent, InputComponent, DatePickerComponent]
})
export class AddSharedBookingAccessPage implements OnInit, OnDestroy {
	private _prefix = 'shared-booking-add';

	public routes = AppConfig.routes;
	public controls: ICustomControl[];
	public sharedAccessForm: FormGroup;
	public submitted = false;

	shareId;
	bookingId;
	type: 'Update' | 'Create' = 'Create';
	isStartDateInvalid = true;
	isEndDateInvalid = true;
	yearsValue;
	showBackBtn: boolean = false;


	constructor(private _formService: FormService,
				private _formBuilder: FormBuilder,
				private loading: CustomSpinnerService,
				private bookingService: UserBookingsApiService,
				private eventsService: EventsService,
				private sharedBookingAccessService: SharedBookingAccessHelperService,
				public nav: IonNav,
				private loader: CustomSpinnerService,
				private modalCtrl: ModalController,
				private alertService: AlertService) {
    addIcons({ chevronBackOutline });
	}

	async ngOnInit() {
		this.controls = this._formService.sharedControls;
		this.bookingId = this.sharedBookingAccessService.booking.id;
		if(this.shareId) {
			this.type = 'Update';
			this.getShareById();
		}
		this.yearsValue = this.getFutureYearsList(10);
		this.createFG();
		this.showBackBtn = await this.nav.canGoBack();
	}

	public ngOnDestroy(): void {
		this.controls.find(c => c.id === 'email').readonly = false;
	}

	async navigateBack() {
		try {
			await this.nav.pop();
		} catch (error) {
			await this.modalCtrl.dismiss();
		}
	}


	private createFG() {
		this.controls.forEach(c => c.title = c.label);
		this.setControlsData();
		if(!this.shareId) {
			this.setControlsValue();
		}
		this.sharedAccessForm = this._formBuilder.group(this._formService.configureControls(this.controls, this._prefix));
		this.sharedAccessForm.valueChanges.subscribe(r => {
			if (this.submitted) {
				this.submitted = false;
			}
		});

		this.sharedAccessForm.get('multipleUse').setValue(false);
	}

	private setControlsData() {
		this._formService.findControl(this.controls, 'startDate').minValue
			= DateHelperService.toIonDateTimeLocalISOString(new Date());

		this._formService.findControl(this.controls, 'endDate').minValue
			= DateHelperService.toIonDateTimeLocalISOString(new Date());
	}

	private setControlsValue() {
		this._formService.findControl(this.controls, 'startDate').value
			= DateHelperService.toIonDateTimeLocalISOString(new Date());

		const now = new Date();
		now.setHours(now.getHours() + 1);
		this._formService.findControl(this.controls, 'endDate').value
			= DateHelperService.toIonDateTimeLocalISOString(now);
	}

	public onSubmit(): any {
		const isDateInvalid = this.validateShare();
		if (this.sharedAccessForm.invalid === true || isDateInvalid === true) {
			return this.submitted = true;
		}

		this.submitted = true;
		this.loading.show().then(() => {
			if (this.type === 'Update') {
				this.update();
			} else if (this.type === 'Create') {
				this.create();
			}
		});
	}

	private validateShare() {
		const share = this.convertShare();
		this.isStartDateInvalid = false;
		if (this.type === 'Create') {
			this.isStartDateInvalid = DateHelperService.isDateLessThan(new Date(), share.startDate);
		}
		this.isEndDateInvalid = DateHelperService.isDateLessThan(share.startDate, share.endDate);
		return this.isStartDateInvalid === true || this.isEndDateInvalid === true;
	}

	private update() {
		const share = this.convertShareForUpdate();
		console.log('share', share);
		this.bookingService.updateShare({
			id: this.bookingId,
			shareId: this.shareId,
			body: {
				...share,
				endDate: new Date(share.endDate).toISOString(),
				startDate: new Date(share.startDate).toISOString()
			}
		}).subscribe(r => {
			console.log('r', r);
			this.loading.hide();
			this.goToSharedList();
		}, error => {
			this.handleError(error);
		});
	}

	private goToSharedList() {
		this.eventsService.refreshBookings();
		this.nav.push(SharedBookingsAccessListPage, { bookingId: this.bookingId});
	}

	private goToSuccessScreen() {
		this.eventsService.refreshBookings();
		this.nav.push(SharedAccessSuccessfullyPage, { bookingId: this.bookingId});
	}

	private create() {
		const share = this.convertShare();
		this.bookingService.createShare({
			id: this.bookingId,
			body: {
				...share,
				endDate: new Date(share.endDate).toISOString(),
				startDate: new Date(share.startDate).toISOString()
			}
		}).subscribe(r => {
			this.loading.hide();
			this.goToSuccessScreen();
		}, error => {
			this.handleError(error);
		});
	}

	private handleError(error) {
		const message: string = error.message;
		if (error.status === 400 && message === 'Booking could not be shared with booking owner') {
			this.alertService.oneButtonsAlert(() => {
			}, AlertType.ShareWithEmailAlreadyShared);
		} else if (error.status === 400 && message && message.includes('User with email')) {
			this.alertService.oneButtonsAlert(() => {
			}, AlertType.ShareWithEmailAlreadyShared);
		} else if (error.status === 400 && message) {
			this.alertService.oneButtonsAlert(() => {
			}, AlertType.Default, error.message);
		} else if (error.status === 400 && error.errors) {
			if (error.errors.startDate) {
				this.isStartDateInvalid = true;
			}
			if (error.errors.endDate) {
				this.isEndDateInvalid = true;
			}
		}
		this.loading.hide();
	}

	private convertShare() {
		const share = this.sharedAccessForm.value;
		share.singleUse = !share.multipleUse;
		return share as CreateShareRequest;
	}

	private convertShareForUpdate() {
		const shareForm = this.sharedAccessForm.value;
		return ({endDate: shareForm.endDate, startDate: shareForm.startDate, singleUse: !shareForm.multipleUse});
	}

	private getShareById() {
		this.bookingService.getBookingShareById({
			id: this.bookingId,
			shareId: this.shareId
		}).subscribe(r => {
			this.setDataForUpdate(r);
		});
	}

	private setDataForUpdate(share: ShareDto) {
		this.setValue('startDate',  DateHelperService.toIonDateTimeLocalISOString(new Date(share.startDate)));
		this.setValue('endDate',  DateHelperService.toIonDateTimeLocalISOString(new Date(share.endDate)));
		this.setValue('multipleUse', !share.singleUse);
		this.setValue('email', share.user.email);
		this.controls.find(c => c.id === 'email').readonly = true;
	}

	setValue(name, value) {
		this.sharedAccessForm.get(name).patchValue(value);
	}

	getControl(name) {
		return this.sharedAccessForm.get(name);
	}

	askRevokeAccess() {
		this.alertService.twoButtonsAlert(() => {
			this.loader.show().then(() => {
				this.revokeAccess(this.shareId);
			});
		}, () => {

		}, AlertType.RevokeAccess);
	}

	revokeAccess(id) {
		this.bookingService.deleteShare({
			id: this.bookingId,
			shareId: id
		}).subscribe(() => {
			this.goToSharedList();
		});
	}

	openLogs() {
		this.nav.push(SharedAccessLogsPage, {bookingId: this.bookingId, shareId: this.shareId});
	}

	getFutureYearsList(numberOfYears: number) {
		return DateHelperService.futureYearsList(numberOfYears);
	}
}
